// 야간 비행등 상태
export enum NightLightsStateEnum {
  CLOSE = 0, // 0-꺼짐
  OPEN = 1, // 1-켜짐
}

// 限远开关
export enum DistanceLimitStatusEnum {
  UNSET = 0, // 0-설정 안 됨
  SET = 1, // 1-설정됨
}

export interface DistanceLimitStatus {
  state?: DistanceLimitStatusEnum;
  distance_limit?: number; // 홈 거리 제한
}

// 장애물 회피 상태
export enum ObstacleAvoidanceStatusEnum {
  CLOSE = 0, // 끄기
  OPEN = 1, // 켜기
}

export interface ObstacleAvoidance {
  horizon?: ObstacleAvoidanceStatusEnum;// 수평 장애물 회피 스위치
  upside?: ObstacleAvoidanceStatusEnum;// 상향 장애물 회피 스위치
  downside?: ObstacleAvoidanceStatusEnum;// 하향 장애물 회피 스위치
}

// 장치 속성 설정
export enum DeviceSettingKeyEnum {
  NIGHT_LIGHTS_MODE_SET = 'night_lights_state', // 야간 항행등 스위치
  HEIGHT_LIMIT_SET = 'height_limit', // 고도 제한 설정
  DISTANCE_LIMIT_SET = 'distance_limit_status', // 홈 거리 제한 스위치
  OBSTACLE_AVOIDANCE_HORIZON = 'obstacle_avoidance_horizon', // 수평 장애물 회피 상태
  OBSTACLE_AVOIDANCE_UPSIDE = 'obstacle_avoidance_upside', // 상향 장애물 회피 상태
  OBSTACLE_AVOIDANCE_DOWNSIDE = 'obstacle_avoidance_downside', // 하향 장애물 회피 상태
}

export type DeviceSettingType = Record<DeviceSettingKeyEnum, any>

export const initDeviceSetting = {
  [DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET]:
  {
    label: '기체 야간 항행등',
    value: '',
    trueValue: NightLightsStateEnum.CLOSE,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: '기체의 비행 안전을 위해 야간 항행등을 켜는 것을 권장합니다',
      label: '기체 야간 항행등',
    },
    settingKey: DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET,
  },
  [DeviceSettingKeyEnum.HEIGHT_LIMIT_SET]:
  {
    label: '고도 제한',
    value: '',
    trueValue: 120,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: '고도 제한: 20 - 1500m',
      // info: '고도 제한 수정은 현재 스테이션의 모든 작업에 영향을 미칩니다. 작업 상황을 확인한 후 수정하는 것을 권장합니다',
      label: '고도 제한',
    },
    settingKey: DeviceSettingKeyEnum.HEIGHT_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.DISTANCE_LIMIT_SET]:
  {
    label: '거리 제한',
    value: '',
    trueValue: DistanceLimitStatusEnum.UNSET,
    // info: '거리 제한(15 - 8000m)은 스테이션 대비 기체의 최대 작업 거리를 제한합니다',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: '거리 제한(15 - 8000m)은 스테이션 대비 기체의 최대 작업 거리를 제한합니다',
      // info: '거리 제한 수정은 현재 스테이션의 모든 작업에 영향을 미칩니다. 작업 상황을 확인한 후 수정하는 것을 권장합니다',
      label: '거리 제한',

    },
    settingKey: DeviceSettingKeyEnum.DISTANCE_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON]:
  {
    label: '수평 장애물 회피',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: '기체의 장애물 회피 작동 상태를 표시하며, 빠르게 켜고 끌 수 있습니다. 추가 설정은 장치 유지보수 페이지에서 가능합니다',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: '장애물 회피는 기체의 비행 안전을 보장하는 기본 기능입니다. 장애물 회피를 켜 두는 것을 권장합니다',
      label: '수평 장애물 회피',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE]:
  {
    label: '상향 장애물 회피',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: '기체의 장애물 회피 작동 상태를 표시하며, 빠르게 켜고 끌 수 있습니다. 추가 설정은 장치 유지보수 페이지에서 가능합니다',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: '장애물 회피는 기체의 비행 안전을 보장하는 기본 기능입니다. 장애물 회피를 켜 두는 것을 권장합니다',
      label: '상향 장애물 회피',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE]:
  {
    label: '하향 장애물 회피',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: '기체의 장애물 회피 작동 상태를 표시하며, 빠르게 켜고 끌 수 있습니다. 추가 설정은 장치 유지보수 페이지에서 가능합니다',
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: '장애물 회피는 기체의 비행 안전을 보장하는 기본 기능입니다. 장애물 회피를 켜 두는 것을 권장합니다',
      label: '하향 장애물 회피',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE,
  },
} as DeviceSettingType

export const initDeviceSettingFormModel = {
  nightLightsState: false, // 야간 항행등 스위치
  heightLimit: 20, // 고도 제한 설정
  distanceLimitStatus: { state: false, distanceLimit: 15 }, // 거리 제한 스위치
  obstacleAvoidanceHorizon: false, // 기체 장애물 회피 - 수평 스위치 설정
  obstacleAvoidanceUpside: false, // 기체 장애물 회피 - 상향 스위치 설정
  obstacleAvoidanceDownside: false, // 기체 장애물 회피 - 하향 스위치 설정
}

export type DeviceSettingFormModel = typeof initDeviceSettingFormModel
